<template>
	<v-ons-page>
		<div class="content">
			<v-ons-list>
				<v-ons-list-header>Latest updated documents</v-ons-list-header>
				<v-ons-list-item v-for="item in recentDocs" :key="item.id" @click="openAttachment(item)">
					<div class="left icon">
						<v-ons-icon icon="fa-file"> </v-ons-icon>
					</div>
					<div class="center">
						{{item.title}} was added to {{ item.document_category }}
						<span class="qf-entry-date">{{item.modified_at | moment}}</span>
					</div>
				</v-ons-list-item>
			</v-ons-list>
		</div>
		<qf-spinner :showing="loadingData" message="Updating contents..."></qf-spinner>
	</v-ons-page>
</template>

<script>
	import Api from '@/services/api';
	import moment from 'moment';
	import SingleDocument from "../singleViews/SingleDocument";
	import QfSpinner from "../shared/QfSpinner";
	import Login from "../login/Login";

	export default {
		name: 'DashboardDocs',
		components: {QfSpinner},
		data() {
			return {
				title: 'Latest from documents',
				recentDocs: [],
				token: '',
				baseUrl: process.env.VUE_APP_BASE_URL,
				loadingData: false
			}
		},
		mounted() {

		},
		computed: {
			defaultProjectLogo(){
				return `https://`+process.env.VUE_APP_VARIANT+`.capecloud.ch/images/placeholder-logo.png`
			},
			currentTabBar(){
				return this.$store.state.shared.homeTabIndex;
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('LLLL');
			}
		},
		methods: {
			fetchDocumentList(){
				this.token = this.$getCookie('access_token');
				let self = this;
				self.loadingData = true;
				if(self.token) {
					Api().get('/dashboard/documents').then(response => {
						//console.log(response.data);
						self.recentDocs = response.data;
						self.loadingData = false;
					}).catch(() => {
						//console.log(err);
						//self.$handleReject()
						self.loadingData = false;
						self.goToLogin();
					});
				}else{
					self.loadingData = false;
					self.goToLogin();
					//self.$handleReject()
				}
			},
			goToLogin(){
				this.$store.commit('navigator/replace', {
					extends: Login,
					data() {
						return {
							bounced: true
						};
					}
				});
			},
			openAttachment(attachment) {
				this.$store.commit('navigator/push', {
					extends: SingleDocument,
					data() {
						return attachment;
					}
				});
			}
		},
		watch: {
			currentTabBar(curTab){
				if(curTab === 3){
					this.fetchDocumentList();
				}
			}
		}
	}
</script>

<style scoped>
	.qf-entry-date {
		font-size:0.75em;
	}
</style>
